import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/types';
import { PhysicalOfferEditInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/physical-offer-interface';
import { usePhysicalProductsList } from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/hooks/use-physical-products-list';
import { getProductListData } from 'modules/funnels/funnel/utils/offer-configuration-utils';
import React, { useEffect, useState } from 'react';
import { FormSelect } from 'shared/components';
interface PhysicalProductSelectorProps {
  currency: CurrencyEnum;
  initialProduct?: PhysicalOfferEditInterface['product'];
  disabled?: boolean;
}
export function usePhysicalProductSelector(t0) {
  const $ = _c(14);
  const {
    currency,
    initialProduct,
    disabled
  } = t0;
  const [localProduct, setLocalProduct] = useState(initialProduct ?? null);
  const {
    physicalProductsList
  } = usePhysicalProductsList(currency);
  let t1;
  let t2;
  if ($[0] !== initialProduct) {
    t1 = () => {
      setLocalProduct(initialProduct ?? null);
    };
    t2 = [initialProduct];
    $[0] = initialProduct;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== physicalProductsList) {
    t3 = physicalProductsList && getProductListData(physicalProductsList);
    $[3] = physicalProductsList;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !physicalProductsList;
  const t5 = localProduct || undefined;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = data => {
      setLocalProduct(data ?? null);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== disabled || $[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t7 = <FormSelect withoutCloseIcon={true} disabled={disabled} data={t3} isPreFetching={t4} value={t5} onChange={t6} />;
    $[6] = disabled;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const Select = t7;
  let t8;
  if ($[11] !== Select || $[12] !== localProduct) {
    t8 = {
      Select,
      localProduct,
      setLocalProduct
    };
    $[11] = Select;
    $[12] = localProduct;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}